export default "__VITE_PUBLIC_ASSET__718cf5b6__"